export const PXBanner = (function () {
  'use strict'

  let videoBtns;

  function init() {
    videoBtns = document.querySelectorAll('.pxblock--banner .play-pause');

    if (videoBtns) {
      videoBtns.forEach(btn => {
        const video = btn.previousElementSibling;
        btn.addEventListener('click', function() {        
          if (video.paused) {
            video.play();
            this.classList.remove('paused');
          } else {
            video.pause();
            this.classList.add('paused');
          }
        });
      });
    }
    events()
  }

  function events() {}

  return { init }
})()
